import { withMetadata } from '../min/metadata'

import { searchPhoneNumbers as _searchPhoneNumbers } from '../es6/findPhoneNumbers'

export function searchPhoneNumbers() {
	return withMetadata(_searchPhoneNumbers, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/index.es6.exports/searchPhoneNumbers.js
// module id = 1tzh
// module chunks = 0 1